import React from "react";
import {transformDateToLongWithCommaAndHour} from "../../../../../utility/dateUtil";
import {getChapterContents, headerTagToMargin} from "../../../../../utility/printViewUtils";

import {
    adpCoverLogo,
    guideCoverBackground,
    guideLegalBackground,
    infoIcon,
    noteIcon,
    resultIcon,
    tipIcon
} from "../../../../../assets/images/guides-pdf";

import './style.css'
import {LoadHtmlFromString} from "../../../../LoadHtmlFromString";


export function ChapterPrintView({guide, chapter}) {
    const chapterIndex = chapter ? chapter - 1 : null

    return (
        <div className='print-container'>
            <div className="print-chapter">
                {/* Needed to pre-fetch images, used as background, in css file to generate PDF */}
                <img src={guideCoverBackground} alt='guide cover background' style={{display: 'none'}}/>
                <img src={guideLegalBackground} alt='guide legal background' style={{display: 'none'}}/>
                <img src={noteIcon} alt='note icon' style={{display: 'none'}}/>
                <img src={tipIcon} alt='tip icon' style={{display: 'none'}}/>
                <img src={infoIcon} alt='info icon' style={{display: 'none'}}/>
                <img src={resultIcon} alt='result icon' style={{display: 'none'}}/>
                {/* --------------------------------------------------------------------------  */}
                <div className="chapter-introduction-container">
                    <div className="chapter-introduction-chapter-number">Chapter {chapter}</div>
                    <div
                        className="chapter-introduction-chapter-title">{guide._source?.navigation?.[chapterIndex]?.title || guide.title}</div>
                    <div
                        className="chapter-introduction-guide-title">{`from ${guide.title}` || guide.title}</div>

                    <div className="published-date">{guide._source.createdAt && <span>Published on<div>{transformDateToLongWithCommaAndHour(new Date(guide._source.createdAt))}</div></span>}</div>
                    <div className="last-modified">{guide._source.modifiedAt && <span>Last modified<div>{transformDateToLongWithCommaAndHour(new Date(guide._source.modifiedAt))}</div></span>}</div>
                    <img className="adp-logo" alt='adp cover logo' src={adpCoverLogo}/>
                </div>
                <div className="print-break"></div>
                <div className="guide-legal-container">
                    <div className="guide-legal-title">ADP Copyright Information</div>
                    <div className="guide-legal-info">
                        <div>ADP, the ADP logo, and Always Designing for People are trademarks of ADP, Inc.</div>
                        <div>Windows is a registered trademark of the Microsoft Corporation.</div>
                        <div>All other trademarks are the property of their respective owners.</div>
                        <div>Copyright © {new Date().getFullYear()} ADP, Inc. ADP Proprietary and Confidential - All
                            Rights
                            Reserved.
                            These materials may not be reproduced in any format without the express written
                            permission
                            of
                            ADP, Inc.
                        </div>
                        <div>These materials may not be reproduced in any format without the express written
                            permission
                            of
                            ADP, Inc.
                            ADP provides this publication “as is” without warranty of any kind, either expressed or
                            implied,
                            including,
                            but not limited to, the implied warranties of merchantability or fitness for a
                            particular
                            purpose.
                            ADP is not responsible for any technical inaccurancies or typographical errors which may
                            be
                            contained in this
                            publication. Changes are periodically made to the information herein, and such changes
                            will
                            be
                            incorporated in
                            new editions of this publication. ADP may make improvements and/or changes in the
                            product
                            and/or
                            the programes
                            described in this publication.
                        </div>
                        <div>{guide._source.createdAt && <span>Published on<div>{transformDateToLongWithCommaAndHour(new Date(guide._source.createdAt))}</div></span>}</div>
                        <div>{guide._source.modifiedAt && <span>Published on<div>{transformDateToLongWithCommaAndHour(new Date(guide._source.modifiedAt))}</div></span>}</div>
                    </div>
                </div>
                <div className="print-break"></div>
                <div className="chapter-contents-list-container">
                    <div className="chapter-contents-list-title">Chapter Contents</div>
                    <div className="chapter-contents-list-chapter-number">Chapter {chapter}</div>
                    <div className="chapter-contents-list-chapter-title">{guide.title}</div>
                    {getChapterContents(guide._source?.navigation?.[chapterIndex].content || guide.content).map((chapterText, index) => {
                        return (
                            <div
                                key={index}
                                className={`chapter-contents-list-headings-title ${headerTagToMargin(chapterText.tagName)}`}>
                                {chapterText.innerText}
                            </div>
                        )
                    })}
                </div>
                <div className="print-break"></div>
                <div className='chapter-content-container'>
                    <div className="chapter-content-chapter-number">Chapter {chapter}</div>
                    <div
                        className="chapter-content-chapter-title">{guide._source?.navigation?.[chapterIndex]?.title || guide.title}</div>

                    <div className="guide-content-container">
                        <LoadHtmlFromString
                            htmlStr={guide._source?.navigation?.[chapterIndex]?.content || guide?.content}/>
                    </div>
                </div>
            </div>

        </div>
    )
}